const TYPE = "transportadora";

const transportadoraModule = {
  findAll: async (dbConnection, limite = null) => {
    let transportadoras = [];
    let result = await dbConnection.find({
      selector: {
        type: { $eq: TYPE },
        status: { $eq: "A" },
      },
      limit: limite === null ? 1000 : limite,
    });

    if (result.docs.length) {
      transportadoras = result.docs;
    }

    return transportadoras;
  },
  findAllByDesc: async (dbConnection, desc) => {
    desc = desc.toUpperCase();
    let transportadoras = [];
    let query = {
      selector: {
        type: { $eq: TYPE },
        status: { $eq: "A" },
        desc: { $regex: desc },
      },
    };

    let result = await dbConnection.find(query);

    if (result.docs.length) {
      transportadoras = result.docs;
    }

    return transportadoras;
  },

  findByIdIntegracao: async (dbConnection, idIntegracao) => {
    let transportadora = null;
    let result = await dbConnection.find({
      selector: {
        type: { $eq: TYPE },
        status: { $eq: "A" },
        idIntegracao: { $eq: idIntegracao },
      },
    });

    if (result.docs.length) {
      transportadora = result.docs[0];
    }

    return transportadora;
  },
};

export default transportadoraModule;
